import { render, staticRenderFns } from "./color-editable-input.vue?vue&type=template&id=edc6c938"
import script from "./color-editable-input.vue?vue&type=script&lang=js"
export * from "./color-editable-input.vue?vue&type=script&lang=js"
import style0 from "./color-editable-input.vue?vue&type=style&index=0&id=edc6c938&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports